/* eslint-disable prettier/prettier */
 import React, { createContext, useContext, useReducer, Dispatch } from 'react';
 import { IinitialState, StepConstants } from '../models/event-reg-refresh-models';

 type DispatchType = Dispatch<providerActions>;

 export const EventRegRefreshContext = createContext<IinitialState | null>(null);
 export const EventRegRefreshDispatchContext = createContext<DispatchType | null>(null);

interface providerState {
  initialState: IinitialState,
  children?: React.ReactNode
}

interface providerActions {
  type: string,
  data?: any
}

export function EventRegRefreshProvider({ initialState, children }: providerState) {
  const [state, dispatch] = useReducer(
    stateReducer,
    initialState
  );

  return (
    <EventRegRefreshContext.Provider value={state}>
      <EventRegRefreshDispatchContext.Provider value={dispatch}>
        {children}
      </EventRegRefreshDispatchContext.Provider >
    </EventRegRefreshContext.Provider>
  );
}

export function useEventRegRefreshContext() {
  return useContext(EventRegRefreshContext);
}

export function useEventRegRefreshDispatch() {
  return useContext(EventRegRefreshDispatchContext);
}

function stateReducer(state: IinitialState, action: providerActions) {
  switch (action.type) {
    case 'updateCurrentStep': {
      // When changing steps, automatically add to visited steps
      const updatedVisitedSteps = state.visitedSteps.includes(action.data)
        ? state.visitedSteps
        : [...state.visitedSteps, action.data];

      return {
        ...state,
        currentStep: action.data,
        visitedSteps: updatedVisitedSteps
      }
    }
    case 'updateUserSelections': {
      return {
        ...state,
        userSelections: action.data
      }
    }
    case 'resetStepsAfter':
      // Reset visited steps after the given step
      const targetStepIndex = getStepIndex(action.data);

      const filteredVisitedSteps = state.visitedSteps.filter(step => {
        const stepIndex = getStepIndex(step);
        return stepIndex <= targetStepIndex;
      });

      return {
        ...state,
        visitedSteps: filteredVisitedSteps
      }
    case 'setShowOnlySharedProgramDateTimeSelection': {
      return {
        ...state,
        showOnlySharedProgramDateTimeSelection: action.data
      }
    }
    case 'setShowOnlySharedAddOnProgramDateTimeSelection': {
      return {
        ...state,
        showOnlySharedAddOnProgramDateTimeSelection: action.data
      }
    }
    case 'clearSharedProgramDateTimeEvents': {
      return {
        ...state,
        sharedProgramDateTimeEvent: null,
        sharedAddOnProgramDateTimeEvent: null,
        showOnlySharedProgramDateTimeSelection: false,
        showOnlySharedAddOnProgramDateTimeSelection: false
      }
    }
    case 'clearSharedAddOnProgramDateTimeEvent': {
      return {
        ...state,
        sharedAddOnProgramDateTimeEvent: null,
        showOnlySharedAddOnProgramDateTimeSelection: false
      }
    }
    default: {
      return state;
    }
  }
}

// Helper function to get the index of a step
const getStepIndex = (stepName: string): number => {
  const stepOrder = [
    StepConstants.ProgramStep,
    StepConstants.AddOnsStep,
    StepConstants.DateTimeSpecialtyProgramStep,
    StepConstants.DateTimeAddOnProgramStep,
    StepConstants.AttendeesStep,
    StepConstants.ReviewStep,
    "DesignSystem"
  ];

  return stepOrder.indexOf(stepName);
};